import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useSearchParams } from '@remix-run/react';

interface Props {
  showLoggedInToast: boolean;
}

// As we move to relying on flash based notifications, we should remove this hook entirely main
const useNotifications = ({ showLoggedInToast }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const subscribeParam = searchParams.get('subscription');
  const optInEmailParam = searchParams.get('opt_in_email');
  const logoutParam = searchParams.get('logout');
  const { t } = useTranslation();

  // Subscription Notifications
  useEffect(() => {
    if (subscribeParam) {
      if (subscribeParam === 'success') {
        toast.success(t('notifications.subscribe.success'));
      } else if (subscribeParam === 'error') {
        toast.error(t('notifications.subscribe.error'));
      }

      // Clear param from url
      searchParams.delete('subscription');
      setSearchParams(searchParams);
    }
  }, [subscribeParam, searchParams, setSearchParams, t]);

  // Logout
  useEffect(() => {
    if (logoutParam) {
      if (logoutParam === 'success') {
        toast.success(t('notifications.logout.success'));
      }

      // Clear param from url
      searchParams.delete('logout');
      setSearchParams(searchParams);
    }
  }, [logoutParam, searchParams, setSearchParams, t]);

  // Optin Email Notifications
  useEffect(() => {
    if (optInEmailParam) {
      if (optInEmailParam === 'error') {
        toast.success(t('notifications.optin.error'));

        // Clear param from url
        searchParams.delete('opt_in_email');
        setSearchParams(searchParams);
      }
    }
  }, [optInEmailParam, searchParams, setSearchParams, t]);

  useEffect(() => {
    if (showLoggedInToast) {
      toast.success(t('login.success.title'));
    }
  }, [showLoggedInToast, t]);
};

export default useNotifications;
